/* src/app/shared-components/mb-tooltip/mb-tooltip.component.scss */
div:first-of-type {
  display: none;
  position: fixed;
  min-width: 160px;
  max-width: calc(100vw - 1rem);
  max-height: calc(100vh - 1rem);
  padding: 0.5rem 0 0.5rem 0;
  overflow-y: auto;
  text-align: left;
  box-sizing: border-box;
  border-radius: 0.75rem;
  box-shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
  border: 1px solid rgba(80, 94, 111, 0.25);
  background-color: rgb(255, 255, 255);
  z-index: 499;
}
div:last-of-type {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 498;
}
/*# sourceMappingURL=mb-tooltip.component.css.map */
